import clsx from "clsx"
import { House, Info, LogIn, LogOutIcon, User } from "lucide-react"

import canopeeWhiteIcon from "@/assets/canopee_icon-blanc-simplifiee-rvb.png"
import { NavbarItems } from "@/features/admin/components/navbar/NavbarItems"
import { useConnectedMe } from "@/features/user/store/me.slice"
import { NavbarItem } from "@/shared/components/NavbarItem"
import { useLogout } from "@/shared/hooks/auth"

interface Props {
	className?: string
}
export function Navbar({ className }: Props) {
	const user = useConnectedMe()
	const handleLogout = useLogout()

	return (
		<nav
			className={clsx(
				className,
				"hidden sm:flex flex-col items-center bg-primary shadow z-max min-w-20 max-w-20 justify-between py-15 overflow-y-auto"
			)}
		>
			<div className="flex flex-col items-center ">
				<img
					alt="Canopée"
					src={canopeeWhiteIcon}
					className="h-auto aspect-square object-cover mb-10 size-11"
				/>
				<div className="flex flex-col gap-10 items-center">
					<NavbarItem type="link" to="/clear-cuts" Icon={House} title="Carte" />
					{user && (
						<NavbarItem
							type="link"
							to="/my-cuts"
							Icon={User}
							title="Mes Coupes"
						/>
					)}
				</div>
			</div>
			<div className="flex flex-col items-center gap-5 ">
				<NavbarItem type="link" to="/about" Icon={Info} title="À propos" />
				{!user && (
					<NavbarItem type="link" to="/login" Icon={LogIn} title="Connexion" />
				)}
				{user?.role === "admin" && <NavbarItems />}
				{user && (
					<NavbarItem
						Icon={LogOutIcon}
						onClick={handleLogout}
						type="button"
						title="Déconnexion"
					/>
				)}
			</div>
		</nav>
	)
}
